const heroModuleButtons = document.querySelectorAll('.hero-module__item');
const heroModuleImages = document.querySelectorAll('.hero-module__bg-images-item');

const removeHeroActiveClass = () => {
  heroModuleImages.forEach((image) => {
    image.classList.remove('is-active');
  });
};

heroModuleButtons.forEach((button) => {
  button.addEventListener('mouseenter', (el) => {
    removeHeroActiveClass();
    const targetImage = el.target.getAttribute('data-button');
    document.querySelector(`[data-image="${targetImage}"]`).classList.add('is-active');
  });
  button.addEventListener('mouseleave', () => {
    removeHeroActiveClass();
  });
});

const pickerItemTicket = document.querySelector('.picker__item--ticket');
const pickerMobile = document.querySelector('.picker');
const body = document.querySelector('body');
const pickerTicketInputs = document.querySelectorAll('.picker__ticket input');
// click on hero module buttons opens header menu

const OpenHeaderPicker = (el) => {
  el.preventDefault();
  const disabledButton = el.target.closest('button').classList.contains('is-disabled');
  if (!disabledButton) {
    const clickIndex = Number(el.target.closest('button').dataset.button || 0);
    if (clickIndex) {
      pickerTicketInputs.forEach((item, k) => {
        if (el.target.closest('button').dataset.url) {
          window.location = el.target.closest('button').dataset.url;
        } else if (k + 1 === clickIndex) {
          const nextStep = pickerItemTicket.nextElementSibling;
          nextStep.classList.toggle('is-active');
          body.classList.toggle('body-scroll-locked');
          body.classList.toggle('overlay-visible');
          pickerMobile.classList.toggle('is-open');
          item.click();
        }
      });
    }
  }
};

heroModuleButtons.forEach((button) => {
  button.addEventListener('click', (event) => {
    if (windowWidth() > breakpointMd) {
      OpenHeaderPicker(event);
    } else {
      setTimeout(() => OpenHeaderPicker(event), 1000);
    }
  });
});

function getPrices(type) {
  fetch(`${localData.apiURL}?action=getPricesForHeader&type=${type}`)
    .then((response) => response.json())
    .then((data) => {
      // eslint-disable-next-line no-use-before-define
      mobiscrollEl.setOptions({
        labels: data,
        valid: data
      });
      document.querySelector('.picker__form #children').closest('.picker__guest-item').hidden = type === 'saunas';
      sendDataToDataLayerSelectItem(type);
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
    });
}

// click on top header menu pools/saunas change prices on header calendar
pickerTicketInputs.forEach((item) => {
  item.addEventListener('click', () => {
    getPrices(item.value);
  });
});

// Check for homepage
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.sc-hero-module')) {
    document.body.classList.add('homepage');
  }
  const urlParams = new URLSearchParams(window.location.search);
  const typeParam = urlParams.get('ticket');
  if (typeParam) {
    const element = document.querySelector(`#${typeParam}`);
    if (element) {
      element.click();
    }
  }
});
